import { render, staticRenderFns } from "./Iceberg.vue?vue&type=template&id=b5ce0086&"
import script from "./Iceberg.vue?vue&type=script&lang=js&"
export * from "./Iceberg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports